import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ApiProviderService } from './api-provider.service';
import { ApplicationConfigService } from './application-config.service';
import { Observable } from 'rxjs';
import { createRequestOption } from '../app/shared/util/request-util';
import { map } from 'rxjs/operators';
import { TransportIncidentItem } from '../models/transport-incident-item.model';
import { TransportIncidentItemService } from './transport-incident-item.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';

export type EntityResponseType = HttpResponse<TransportIncidentItem>;
export type EntityArrayResponseType = HttpResponse<TransportIncidentItem[]>;

@Injectable({ providedIn: 'root' })
export class TransportIncidentItemExtendedService extends TransportIncidentItemService {
  protected override resourceUrl = API_ENDPOINTS.TRANSPORT_INCIDENT_ITEMS;

  constructor(protected apiProvider: ApiProviderService, protected httpClient: HttpClient, protected override applicationConfigService: ApplicationConfigService) {
    super(httpClient, applicationConfigService);
  }

  override query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider
      .get<TransportIncidentItem[]>(this.resourceUrl, {
        params: options,
        observe: 'response',
      })
      .pipe(map((res: EntityArrayResponseType) => res));
  }
}
